import React from 'react';

import CloseIcon from 'icons/ic-close.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';
import ProfilePhotoDisplay from 'components/application/ProfilePhotoDisplay';

import { personDisplayName } from 'components/helpers/users';

export default function SelectedPersonnelCard({
  email,
  firstName,
  lastName,
  onClose,
  onEdit,
  profilePhotoUrl,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <span className='tw-mb-8 tw-inline-flex tw-w-full tw-rounded-md tw-border-1 tw-border-solid tw-border-grey-100 tw-bg-white tw-p-4'>
      <ProfilePhotoDisplay
        componentSize='sm'
        photoUrl={profilePhotoUrl}
        profileInitials={`${firstName[0]}${lastName[0]}`}
      />
      <span className='tw-ml-3 tw-flex-auto'>
        <span className='tw-font-medium tw-text-grey-900'>
          {personDisplayName({ attributes: { firstName, lastName } })}
        </span>
        <CloseIcon
          className='handshq--hoverable pull-right [&_polygon]:tw-fill-grey-700'
          height={24}
          onClick={onClose}
          width={24}
        />
        <div className='tw-mb-3'>{email}</div>
        <OutlinedButton color='grey' onClick={onEdit} size='sm'>
          {i18nTShared('edit')}
        </OutlinedButton>
      </span>
    </span>
  );
}

SelectedPersonnelCard.propTypes = {
  email: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};
